module.exports = __webpack_public_path__ + "media/images/design/common/images/menu02-400bbacf5d729fec8b5db174ac20cbd0.jpg";